import { HOUR_TO_MILLISECONDS_FACTOR } from 'technical/time-utils/constants';
import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';

import { GRAPH_NUMBER_OF_STEPS } from './constants';

/**
 * @name getIntervalValues
 *
 * @param graphMaxValue
 * @param intervalMaxInput
 * @param numberOfSteps
 *
 * @description Used for to get round number on the Exca and Build duration graph.
 * Since the values are milliseconds, the base 10 cause the interval to display
 * in HH:mm values like 4:34 or 1:05 which are not realy nice to look at when
 * we expect round hours
 *
 * Therefore we create the step manually. The goal is to display a fixed number of
 * steps based on numberOfSteps
 */
export const getIntervalValues = (
  graphMaxValue: number,
  intervalMaxInput: number | null | undefined,
  numberOfSteps: number = GRAPH_NUMBER_OF_STEPS,
) => {
  let maxValue: number;
  if (!isUndefinedOrNull(intervalMaxInput)) {
    maxValue = intervalMaxInput;
  } else {
    // Add a small number because we truncate. Otherwise the graph display
    // one more step which can be quite big depending on the graphMaxValue
    // Not required for the interval since it's based on user input
    maxValue = Math.trunc(graphMaxValue + 1);
  }

  // To get only GRAPH_NUMBER_OF_STEPS step each time, we take the maxValue of
  // the graph which can be either a graph value or the user choosen scale
  // Divide by GRAPH_NUMBER_OF_STEPS to get only this number of steps
  let stepFactor = maxValue / numberOfSteps;

  // If the maxValue is 1 or less, the factor is 0 which cause the steps to be
  // manualy managed by AgChart but we want to control it anyway
  if (!stepFactor) {
    stepFactor = 0.25;
  }

  const intervalStep = HOUR_TO_MILLISECONDS_FACTOR * stepFactor;

  const values: number[] = [];
  for (let idx = 1; idx <= numberOfSteps; idx += 1) {
    // Enforce the last value to be the exact hour of the maxValue
    if (idx === numberOfSteps) {
      values.push(maxValue * HOUR_TO_MILLISECONDS_FACTOR);
    }

    values.push(idx * intervalStep);
  }

  return values;
};
